<template>
  <div class="page-wrap">
    <el-card class="page-card--full">
      <div class="page-card-body" ref="pageRoot">
        <div ref="queryBar" style="display:flex;gap:12px;align-items:center;flex-wrap:wrap;">
          <el-button type="primary" @click="openCreate">新增角色</el-button>
        </div>

        <el-table :data="list" :height="tableHeight" style="width:100%;" size="small">
          <el-table-column prop="name" label="名称" />
          <el-table-column prop="code" label="编码" width="160" />
          <el-table-column prop="status" label="状态" width="100">
            <template slot-scope="s">
              <el-tag :type="s.row.status===1?'success':'info'">{{ s.row.status===1?'启用':'停用' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="260">
            <template slot-scope="s">
              <el-button type="text" @click="openMenuAssign(s.row)">分配菜单</el-button>
              <el-button type="text" @click="openEdit(s.row)">编辑</el-button>
              <el-button type="text" style="color:#ef4444" @click="remove(s.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-dialog :title="form.id?'编辑角色':'新增角色'" :visible.sync="dlg" width="420px">
        <el-form :model="form" label-width="90px">
          <el-form-item label="名称"><el-input v-model="form.name" /></el-form-item>
          <el-form-item label="编码"><el-input v-model="form.code" :disabled="!!form.id" /></el-form-item>
          <el-form-item label="状态">
            <el-select v-model="form.status" style="width:100%">
              <el-option :value="1" label="启用" />
              <el-option :value="0" label="停用" />
            </el-select>
          </el-form-item>
          <el-form-item label="备注"><el-input v-model="form.remark" /></el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="dlg=false">取消</el-button>
          <el-button type="primary" :loading="saving" @click="save">保存</el-button>
        </span>
      </el-dialog>

      <el-dialog title="分配菜单" :visible.sync="menuDlg" width="680px" destroy-on-close>
        <div v-loading="menuLoading" style="display:flex;flex-direction:column;gap:10px;height:520px;">
          <div style="display:flex;align-items:center;justify-content:space-between;gap:12px;">
            <div style="color:#64748b;font-size:12px;line-height:1.4;">
              角色：<b>{{ currentRole ? (currentRole.name + '（' + currentRole.code + '）') : '-' }}</b>
              <span style="margin-left:10px;">勾选后保存；会自动包含父级目录。</span>
            </div>
            <div style="flex:0 0 auto;">
              <el-button size="mini" @click="checkAllMenus">全选</el-button>
              <el-button size="mini" @click="clearMenus">清空</el-button>
            </div>
          </div>

          <div style="flex:1;min-height:0;overflow:auto;border:1px solid #e5e7eb;border-radius:8px;padding:10px;background:#fff;">
            <el-tree
              ref="menuTree"
              :data="menuTree"
              node-key="id"
              show-checkbox
              default-expand-all
              :props="treeProps"
              :expand-on-click-node="false"
            >
              <span slot-scope="{ data }" class="tree-node">
                <span>{{ data.name }}</span>
                <span class="tree-node__meta">{{ data.perms || data.path || '' }}</span>
              </span>
            </el-tree>
          </div>
        </div>

        <span slot="footer">
          <el-button @click="menuDlg=false">取消</el-button>
          <el-button type="primary" :loading="menuSaving" @click="saveRoleMenus">保存</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request from '../../utils/request'
import tableAutoHeight from '../../mixins/tableAutoHeight'

export default {
  name: 'SysRole',
  mixins: [tableAutoHeight],
  data() {
    return {
      list: [],
      dlg: false,
      saving: false,
      form: { id: '', name: '', code: '', status: 1, remark: '' },

      menuDlg: false,
      menuLoading: false,
      menuSaving: false,
      currentRole: null,
      menuTree: [],
      treeProps: { label: 'name', children: 'children' }
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.list = await request.get('/admin/api/sys/role/list')
      this.$nextTick(() => this.updateTableHeight())
    },
    openCreate() {
      this.form = { id: '', name: '', code: '', status: 1, remark: '' }
      this.dlg = true
    },
    openEdit(row) {
      this.form = { id: row.id, name: row.name, code: row.code, status: row.status, remark: row.remark }
      this.dlg = true
    },
    async save() {
      if (this.saving) return
      this.saving = true
      try {
        if (this.form.id) {
          await request.put('/admin/api/sys/role/' + this.form.id, this.form)
        } else {
          await request.post('/admin/api/sys/role', this.form)
        }
        this.$message.success('已保存')
        this.dlg = false
        await this.load()
      } finally {
        this.saving = false
      }
    },
    async remove(row) {
      await this.$confirm('确认删除该角色？', '提示', { type: 'warning' })
      await request.delete('/admin/api/sys/role/' + row.id)
      this.$message.success('已删除')
      await this.load()
    },

    async openMenuAssign(role) {
      this.currentRole = role
      this.menuDlg = true
      this.menuLoading = true
      try {
        const [tree, res] = await Promise.all([
          request.get('/admin/api/sys/menu/tree'),
          request.get('/admin/api/sys/role/' + role.id + '/menus')
        ])

        this.menuTree = Array.isArray(tree) ? tree : []
        const menuIds = res && Array.isArray(res.menuIds) ? res.menuIds : []

        this.$nextTick(() => {
          const t = this.$refs.menuTree
          if (t && typeof t.setCheckedKeys === 'function') {
            t.setCheckedKeys(menuIds)
          }
        })
      } finally {
        this.menuLoading = false
      }
    },
    flattenMenuIds(nodes) {
      const out = []
      const walk = (arr) => {
        ;(arr || []).forEach((n) => {
          if (!n || !n.id) return
          out.push(n.id)
          if (Array.isArray(n.children) && n.children.length) walk(n.children)
        })
      }
      walk(nodes)
      return out
    },
    checkAllMenus() {
      const t = this.$refs.menuTree
      if (!t) return
      const ids = this.flattenMenuIds(this.menuTree)
      t.setCheckedKeys(ids)
    },
    clearMenus() {
      const t = this.$refs.menuTree
      if (!t) return
      t.setCheckedKeys([])
    },
    async saveRoleMenus() {
      if (this.menuSaving) return
      if (!this.currentRole) return

      const t = this.$refs.menuTree
      // 仅保存“实际勾选”的菜单，避免半选父级导致下次打开时被自动勾回。
      const menuIds = t && typeof t.getCheckedKeys === 'function' ? t.getCheckedKeys() : []

      this.menuSaving = true
      try {
        await request.put('/admin/api/sys/role/' + this.currentRole.id + '/menus', { menuIds })
        this.$message.success('已保存')
        this.menuDlg = false
      } finally {
        this.menuSaving = false
      }
    }
  }
}
</script>

<style scoped>
.tree-node {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.tree-node__meta {
  color: #94a3b8;
  font-size: 12px;
}
</style>
